export const getDayName = (date: Date): string => {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const dayIndex = date.getDay()
    return daysOfWeek[dayIndex] ?? 'Sunday'
}
